// extracted by css-extract-rspack-plugin
export default {"MobileCta":"MobileCta-module__MobileCta__bxNEM","MobileCta__message":"MobileCta-module__MobileCta__message__zyqli"};